import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-006a08e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "subAccount_list"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "list_line_right" }
const _hoisted_5 = { class: "subAccount_list_name" }
const _hoisted_6 = { class: "subAccount_list_content" }
const _hoisted_7 = { class: "list_content_live" }
const _hoisted_8 = { class: "content_live_num" }
const _hoisted_9 = { class: "text_color" }
const _hoisted_10 = {
  key: 2,
  class: "subAccount_pagination"
}
const _hoisted_11 = { class: "subAccount_modal" }
const _hoisted_12 = { class: "modal_top" }
const _hoisted_13 = { class: "modal_top_left modal_align_center" }
const _hoisted_14 = { class: "modal_align_center" }
const _hoisted_15 = { class: "text_color" }
const _hoisted_16 = { class: "modal_align_center" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "删除", -1))
const _hoisted_18 = {
  key: 0,
  class: "subAccount_modal_list",
  "infinite-scroll-distance": "20",
  "infinite-scroll-immediate": "false",
  style: {"overflow":"auto"}
}

import CDelModal from '@/components/CDelModal.vue';
import { ref, reactive } from 'vue';
import { DatePicker, Input, Pagination, Modal } from 'ant-design-vue';
import LiveItemSquare from '@/components/liveItem/LiveItemSquare.vue';
import moment from 'moment';
import http from '@/api/home';
import { emptyDataSec } from '@/assets';
import CLoading from '@/components/CLoading.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Subt',
  setup(__props) {

const { RangePicker } = DatePicker;
const aRangePicker = RangePicker;
const aInputSearch = Input.Search;
const aPagination = Pagination;
const aModal = Modal;

// 分页器
const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 10, // 每页条数
  totalSize: 0, // 总数
  options: ['10', '20', '30', '40', '50'], // 选项
});
let subAccountList: any = ref([]);
const accountDate = ref();
const keywords = ref();
const showLoading = ref(false);
// 获取子账号列表
const getChildList = () => {
  showLoading.value = false;
  const state_time = accountDate.value ? moment(accountDate.value[0]).format('YYYY-MM-DD HH:mm') : '';
  const end_time = accountDate.value ? moment(accountDate.value[1]).format('YYYY-MM-DD HH:mm') : '';
  const data = {
    keywords: keywords.value,
    page: pageConfig.current,
    page_num: pageConfig.pageSize,
    state_time: state_time,
    end_time: end_time,
  };
  http
    .getChildDetailList({ params: data })
    .then((res) => {
      const resData = res.data.data;
      subAccountList.value = [];
      subAccountList.value = resData.data ? [...resData.data] : [];
      pageConfig.totalSize = resData.total;
    })
    .finally(() => {
      showLoading.value = true;
    });
};
getChildList();

// 打开弹框
const ListData: any = ref([]);
const selectKeys = ref({});
const visible = ref<boolean>(false);
const admin_id = ref();
const showModal = (id: number) => {
  visible.value = true;
  admin_id.value = id;
  modalData.value = {
    page: 0,
    last_page: 0,
    total: 0,
    choice: false,
    keywords: modalData.value.keywords,
    select: false,
    selectAll: false,
  };
  ListData.value = [];
  selectKeys.value = [];
  getChildLiveList();
};

// 获取子账号直播间列表
let modalData = ref({
  page: 0,
  last_page: 0,
  total: 0,
  choice: false,
  keywords: '',
  select: false,
  selectAll: false,
});
const getChildLiveList = () => {
  if (modalData.value.page <= modalData.value.last_page) {
    modalData.value.page++;
    const data = {
      admin_id: admin_id.value,
      keywords: modalData.value.keywords,
      page: modalData.value.page,
      page_num: 10,
    };
    http.getChildLiveRoomList({ params: data }).then((res) => {
      modalData.value.last_page = res.data.data.last_page;
      modalData.value.total = res.data.data.total;
      ListData.value.push(...res.data.data.data);
      ListData.value.map((res: any) => {
        selectKeys.value[res.id] = modalData.value.selectAll;
      });
    });
  }
};

// 选择
const getSelect = () => {
  modalData.value.choice = modalData.value.select;
  modalData.value.selectAll = false;
  selectLive();
};
// 全选
const getSelectAll = () => {
  modalData.value.select = false;
  modalData.value.choice = !modalData.value.choice;
  Object.keys(selectKeys.value).forEach((res) => {
    selectKeys.value[res] = modalData.value.selectAll;
  });
  selectLive();
};

// 点击直播间
const getSelectKeys = (id: string) => {
  selectKeys.value[id] = !selectKeys.value[id];
  selectLive();
};

// 删除直播间
const deleteKey = ref<boolean>(false);
const openDelModal = () => {
  deleteKey.value = false;
};
const deteleLive = () => {
  selectLiveList.value.length > 0 ? (deleteKey.value = true) : '';
};
const deteleSelect = () => {
  selectLive();
  if (selectLiveList.value.length > 0) {
    const data = {
      studio_id: selectLiveList.value.join(','),
      child_accounts_id: admin_id.value,
    };
    http.delLiveStudioChildStudio({ params: data }).then(() => {
      deleteKey.value = false;
      showModal(admin_id.value);
      selectLive();
    });
  }
};

// 选中直播间
const selectLiveList: any = ref([]);
const selectLive = () => {
  selectLiveList.value = [];
  Object.keys(selectKeys.value).forEach((res) => {
    selectKeys.value[res] ? selectLiveList.value.push(res) : '';
  });
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_unref(aRangePicker), {
        ranges: {
          今天: [_unref(moment)().startOf('day'), _unref(moment)().endOf('day')],
          最近一周: [_unref(moment)().startOf('day').subtract(1, 'weeks'), _unref(moment)()],
          最近一月: [_unref(moment)().startOf('day').subtract(1, 'months'), _unref(moment)()],
          最近三月: [_unref(moment)().startOf('day').subtract(3, 'months'), _unref(moment)()],
        },
        "show-time": { format: 'HH:mm' },
        format: "YYYY-MM-DD HH:mm",
        onOk: getChildList,
        value: accountDate.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((accountDate).value = $event)),
        class: "mod_range_picker"
      }, {
        suffixIcon: _withCtx(() => [
          _createVNode(_component_svg_icon, { "icon-class": "icon_time" })
        ]),
        _: 1
      }, 8, ["ranges", "value"]),
      _createVNode(_unref(aInputSearch), {
        value: keywords.value,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((keywords).value = $event)),
        placeholder: "搜索账号",
        "enter-button": "",
        class: "mod_range_picker_search",
        onSearch: getChildList
      }, null, 8, ["value"])
    ]),
    (!showLoading.value)
      ? (_openBlock(), _createBlock(CLoading, { key: 0 }))
      : _createCommentVNode("", true),
    (showLoading.value && _unref(subAccountList).length !== 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subAccountList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "subAccount_list_line",
              key: index,
              onClick: ($event: any) => (showModal(item.id))
            }, [
              _createElementVNode("img", {
                class: "list_line_img",
                src: item.image_avatar_url,
                alt: ""
              }, null, 8, _hoisted_3),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, "姓名：" + _toDisplayString(item.name), 1),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", null, "账号ID：" + _toDisplayString(item.mobile), 1),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createTextVNode(" 直播间数量： "),
                      _createElementVNode("div", _hoisted_9, _toDisplayString(item.count_room), 1),
                      _createTextVNode(" 个 ")
                    ]),
                    _createElementVNode("div", null, "创建时间： " + _toDisplayString(item.created_at), 1)
                  ])
                ])
              ])
            ], 8, _hoisted_2))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (showLoading.value && _unref(subAccountList).length !== 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_unref(aPagination), {
            "show-quick-jumper": "",
            total: pageConfig.totalSize,
            current: pageConfig.current,
            "onUpdate:current": _cache[2] || (_cache[2] = ($event: any) => ((pageConfig.current) = $event)),
            "page-size": pageConfig.pageSize,
            "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((pageConfig.pageSize) = $event)),
            pageSizeOptions: pageConfig.options,
            "show-less-items": "",
            "show-size-changer": "",
            onChange: getChildList,
            onShowSizeChange: getChildList
          }, null, 8, ["total", "current", "page-size", "pageSizeOptions"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(aModal), {
      visible: visible.value,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((visible).value = $event)),
      width: "80%",
      title: "临时账号",
      footer: null,
      centered: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_unref(aInputSearch), {
                value: _unref(modalData).keywords,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(modalData).keywords) = $event)),
                placeholder: "搜索直播间标题",
                class: "mod_range_picker_search",
                onSearch: _cache[5] || (_cache[5] = ($event: any) => (showModal(admin_id.value)))
              }, null, 8, ["value"]),
              _createElementVNode("div", _hoisted_14, [
                _createTextVNode(" 直播间： "),
                _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(modalData).total), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_a_checkbox, {
                checked: _unref(modalData).select,
                "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => ((_unref(modalData).select) = $event)),
                onChange: getSelect,
                class: "modal_operation"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("选择")
                ]),
                _: 1
              }, 8, ["checked"]),
              _createVNode(_component_a_checkbox, {
                checked: _unref(modalData).selectAll,
                "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => ((_unref(modalData).selectAll) = $event)),
                onChange: getSelectAll,
                class: "modal_operation"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("全选")
                ]),
                _: 1
              }, 8, ["checked"]),
              _createElementVNode("div", {
                class: _normalizeClass([selectLiveList.value.length > 0 ? 'modal_delete_select' : 'modal_delete', "modal_align_center"]),
                onClick: deteleLive
              }, [
                _createVNode(_component_svg_icon, {
                  class: "mod_btn_icon",
                  "icon-class": "del"
                }),
                _hoisted_17
              ], 2)
            ])
          ]),
          (ListData.value.length !== 0)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ListData.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "modal_list",
                    key: item.id
                  }, [
                    _createVNode(LiveItemSquare, {
                      "data-source": item,
                      choice: _unref(modalData).choice,
                      selected: selectKeys.value[item.id],
                      onClick: ($event: any) => (getSelectKeys(item.id))
                    }, null, 8, ["data-source", "choice", "selected", "onClick"])
                  ]))
                }), 128))
              ])), [
                [_directive_infinite_scroll, getChildLiveList]
              ])
            : _createCommentVNode("", true),
          (ListData.value.length == 0)
            ? (_openBlock(), _createBlock(_component_a_empty, {
                key: 1,
                class: "empty_wrap",
                image: _unref(emptyDataSec),
                description: "页面暂无数据信息~",
                style: {"height":"calc(60vh - 70px)"}
              }, null, 8, ["image"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(CDelModal, {
      visible: deleteKey.value,
      centered: "",
      close: openDelModal,
      ok: deteleSelect
    }, null, 8, ["visible"]),
    (showLoading.value && _unref(subAccountList).length == 0)
      ? (_openBlock(), _createBlock(_component_a_empty, {
          key: 3,
          class: "empty_wrap",
          image: _unref(emptyDataSec),
          description: "页面暂无数据信息~"
        }, null, 8, ["image"]))
      : _createCommentVNode("", true)
  ]))
}
}

})